import styled from 'styled-components';

import Button from '@components/Button/next';

import { Footer as DefaultFooter } from '../styled';
export const GuestCount = styled.div`
  border: 2px solid ${({ theme }) => theme.palette.gray87};
  padding: 12px 22px;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  @media (max-width: 500px) {
    flex-direction: column;
    justify-content: center;
    align-items: space-between;
  }
`;

export const FormContainer = styled.div``;

export const CounterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const CounterLabel = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const FlightTripTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const TransferContainer = styled.div`
  border-left: 2px solid ${({ theme }) => theme.palette.gray87};
  padding-left: 20px;

  @media (max-width: 500px) {
    width: inherit;
    border-left: initial;
    padding-left: initial;
  }
`;

export const DateText = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
`;

export const RadioGroupContainer = styled.div`
  & label {
    width: 100% !important;
  }
  & span {
    display: inline-block;
    width: 100% !important;
  }
`;

export const StyledButton = styled(Button)`
  height: 58px;
  width: 250px;

  span {
    font-size: 18px;
    font-weight: bold;
  }

  @media (max-width: 500px) {
    width: inherit;
    position: initial;
    bottom: initial;
  }
`;

StyledButton.defaultProps = {
  variant: 'Primary',
};
export const Footer = styled(DefaultFooter)`
  @media (max-width: 500px) {
    position: initial;
    bottom: initial;
  }
`;
